// Copyright 2024 Sorama B.V.

interface CanvasRenderingContext2D {
    /**
     * Draws a circle path
     */
    circle(x: number, y: number, radius: number): void;

    /**
     * Draws a line path from (x1, y1) to (x2, y2)
     */
    line(x1: number, y1: number, x2: number, y2: number): void;

    /**
     * Draws a rounded rectangle path
     */
    roundRect(x: number, y: number, width: number, height: number, radius: number): void;
}

CanvasRenderingContext2D.prototype.circle = function (
    this: CanvasRenderingContext2D,
    x: number,
    y: number,
    radius: number
) {
    this.beginPath();
    this.arc(x, y, radius, 0, 2 * Math.PI);
    this.closePath();
};

CanvasRenderingContext2D.prototype.line = function (
    this: CanvasRenderingContext2D,
    x1: number,
    y1: number,
    x2: number,
    y2: number
) {
    this.beginPath();
    this.moveTo(x1, y1);
    this.lineTo(x2, y2);
    this.closePath();
};

CanvasRenderingContext2D.prototype.roundRect = function (
    this: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    radius: number
) {
    this.beginPath();
    this.moveTo(x + radius, y);
    this.arcTo(x + width, y, x + width, y + height, radius);
    this.arcTo(x + width, y + height, x, y + height, radius);
    this.arcTo(x, y + height, x, y, radius);
    this.arcTo(x, y, x + width, y, radius);
    this.closePath();
};
